import {
    AspectRatio,
    Box,
    Flex,
    Grid,
  } from '@theme-ui/components'
  import { Container, PageBanner, PageHeader, Skeleton } from '~/Common'
  
  export const IndustriesViewSkeleton = () => {
    return (
      <>
        {/* Banner & Header */}
        <PageBanner img={'industries'}>
          <PageHeader sx={{ position: 'relative' }}>
            <Container
              variant="layouts.default"
              sx={{ maxWidth: ['812px', '812px', '812px', '1392px'] }}
            >
              <Grid
                sx={{
                  position: 'relative',
                  gridGap: [4, 4, 4, 5],
                  gridTemplateColumns: ['1fr', null, null, '2fr 3fr', 'auto 780px'],
                  width: '100%',
                }}
              >
                <Box sx={{ position: 'relative', order: [2, 2, 2, 0] }}>
                  <Skeleton height="36px" width="100px" mb={4} sx={{ borderRadius: '999px' }} />
  
                  <Box mb={5}>
                    <Skeleton height="48px" width="80%" mb={2} />
                    <Skeleton height="133px" width="100%" mb={2} />
                  </Box>
  
                  <Box mb={3}>
                    <Skeleton height="46px" width="150px" mb={2} />
                  </Box>
                </Box>
                <Box
                  sx={{
                    maxWidth: ['none', 'none', 'none', '820px'],
                    position: 'relative',
                    order: [0, 0, 0, 2],
                  }}
                >
                  <AspectRatio
                    ratio={16 / 9}
                    sx={{
                      borderRadius: '32px',
                      overflow: 'hidden',
                    }}
                  >
                    <Skeleton height="100%" />
                  </AspectRatio>
                </Box>
              </Grid>
            </Container>
          </PageHeader>
        </PageBanner>
  
        {/* Main Content */}
        <Container
          variant="layouts.default"
          sx={{ maxWidth: ['812px', '812px', '812px', '1392px'], zIndex: 999, position: 'relative' }}
        >
          <Grid sx={{ gridGap: [4, 4, 4, 5], width: '100%' }}>
            {/* Industry Breakdown (Sub-categories) */}
            <Box>
              <Skeleton mx="auto" height="42px" width="200px" mb={3} sx={{ borderRadius: '999px' }} />
              <Flex sx={{ flexWrap: 'wrap', justifyContent: 'center', gap: 5 }}>
                {[1, 2, 3].map((i) => (
                  <Flex key={i} sx={{ my: 3, alignItems: 'center', flexDirection: 'column' }}>
                    <Skeleton height="70px" width="70px" mb={4} />
                    <Skeleton height="29px" width="150px" />
                  </Flex>
                ))}
              </Flex>
            </Box>
  
            {/* About the Industry */}
            <Box sx={{ textAlign: 'center', mt: 5 }}>
              <Skeleton height="48px" width="30%" mx="auto" mb={3} />
              <Skeleton height="14px" width="80%" mx="auto" mb={2} />
              <Skeleton height="14px" width="80%" mx="auto" mb={2} />
              <Skeleton height="14px" width="80%" mx="auto" />
            </Box>
  
            {/* Featured Company */}
            <Box sx={{ mt: 6, mb: 3 }}>
              <Skeleton height="36px" width="50%" mb={3} />
              <Skeleton height="200px" width="100%" />
            </Box>
  
            {/* Latest Industry Announcements */}
            <Box sx={{ mt: 6, mb: 3 }}>
              <Skeleton height="36px" width="40%" mb={3} />
              <Grid
                sx={{
                  gridGap: 4,
                  gridTemplateColumns: ['1fr', '1fr', '1fr', '1fr'],
                  width: '100%',
                }}
              >
                {[1, 2, 3, 4].map((i) => (
                  <Box key={i}>
                    <Skeleton height="150px" width="100%" mb={2} />
                    <Skeleton height="16px" width="80%" mb={1} />
                    <Skeleton height="14px" width="60%" />
                  </Box>
                ))}
              </Grid>
            </Box>
  
            {/* Current Industry Deals */}
            <Box sx={{ mt: 6 }}>
              <Skeleton height="36px" width="40%" mb={3} />
              <Grid
                sx={{
                  gridGap: 4,
                  gridTemplateColumns: ['1fr', '1fr', '1fr'],
                  width: '100%',
                }}
              >
                {[1, 2, 3].map((i) => (
                  <Box key={i}>
                    <Skeleton height="200px" width="100%" />
                  </Box>
                ))}
              </Grid>
            </Box>
  
            {/* Explore Companies */}
            <Box sx={{ mt: 6, mb: 3 }}>
              <Skeleton height="36px" width="40%" mb={3} />
              <Grid
                sx={{
                  gridGap: 4,
                  gridTemplateColumns: ['1fr', '1fr', '1fr'],
                  width: '100%',
                }}
              >
                {[1, 2, 3, 4].map((i) => (
                  <Box key={i}>
                    <Skeleton height="200px" width="100%" />
                  </Box>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Container>
      </>
    )
  }
  
  export default IndustriesViewSkeleton
  